<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false" normalWidth="800px" set-class="no-padding">
    <Vimeo :url="params.url" />
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import Vimeo from '@/components/components/Vimeo';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    Vimeo,
  },
  data() {
    return {
    };
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
    ]),
  },
  filters: {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
</style>



// WEBPACK FOOTER //
// MovieModal.vue?32e3f278